import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { selectIsAuthenticated } from '../store/slices/authSlice';
import { MainLayout } from '../components/layout';

interface PrivateRouteProps {
  children: React.ReactNode;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  // Obtener estado de autenticación del Redux store
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  if (!isAuthenticated) {
    // Redirigir al login si no está autenticado
    return <Navigate to="/login" replace />;
  }

  // Renderizar con layout protegido (con sidebar)
  return (
    <MainLayout isAuthenticated={true} showSidebar={true}>
      {children}
    </MainLayout>
  );
};

